// ponytail: module-level singleton so the class-based shell can call fitView()
// without being inside a ReactFlowProvider. LineageCanvas writes here on onInit;
// LineageEditorShell reads here for doTidy/doPrint.
export const rfRef = {current: null};
export const setRfInstance = (inst) => {
  rfRef.current = inst;
};
